import Skeleton from "@/v2-ui/skeleton"
import cn from "@/v2-ui/utils/utils.cn"

export type FeatureAccessSkeletonProps = {
  className?: string
}

/**
 * The access section's shape while the feature row lands: the Availability
 * label and its select, the Save button, its explainer line, and the
 * personal-data checkbox.
 */
function FeatureAccessSkeleton(props: FeatureAccessSkeletonProps) {
  const { className } = props

  return (
    <div className={cn("flex flex-col gap-3", className)} aria-busy="true">
      <div className="flex items-start gap-3">
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-9 w-full max-w-md rounded-md" />
          <Skeleton className="h-3 w-56" />
        </div>
        <Skeleton className="h-8 w-16 rounded-md" />
      </div>
      <div className="flex items-start gap-2">
        <Skeleton className="size-4 shrink-0 rounded-sm" />
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-80" />
        </div>
      </div>
    </div>
  )
}

export default FeatureAccessSkeleton
